import actionCreatorFactory from 'typescript-fsa';

export const actionCreator = actionCreatorFactory();

export const NavigationActions = {
  setLastNode: actionCreator<{ courseId: string; lastNode: string }>('SET_LAST_NODE'),
  deleteLastNode: actionCreator<{ courseId: string }>('DELETE_LAST_NODE')
};
